import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './SectionHomeMission.module.css';

const SectionHomeMission = () => {
  return (
    <div className={css.zone}>
      <section className={css.mission}>
        <svg className={css.ring} width="190" height="190" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="#3A3122">
            <circle cx="20.5" cy="12" r="1.1" />
            <circle cx="18" cy="18" r="1.1" />
            <circle cx="12" cy="20.5" r="1.1" />
            <circle cx="6" cy="18" r="1.1" />
            <circle cx="3.5" cy="12" r="1.1" />
            <circle cx="6" cy="6" r="1.1" />
            <circle cx="12" cy="3.5" r="1.1" />
          </g>
          <circle cx="18" cy="6" r="1.3" fill="#8A5330" />
        </svg>
        <div className={css.eyebrow}>
          <FormattedMessage id="LandingPage.mobileHome.mission.eyebrow" />
        </div>
        <blockquote className={css.quote}>
          <FormattedMessage id="LandingPage.mobileHome.mission.quote" />
        </blockquote>
        <p className={css.body}>
          <FormattedMessage id="LandingPage.mobileHome.mission.body" />
        </p>
        <a
          className={css.cta}
          href="https://setcircle.info/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="LandingPage.mobileHome.mission.cta" />
        </a>
        <p className={css.micro}>
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M4.5 12.5 l5 5 10-11" />
          </svg>
          <FormattedMessage id="LandingPage.mobileHome.mission.micro" />
        </p>
      </section>
    </div>
  );
};

export default SectionHomeMission;
